import React, { createContext, useContext, useState } from 'react';

const PartnerContext = createContext();

export const usePartner = () => useContext(PartnerContext);

export const PartnerProvider = ({ children }) => {
  const [org, setOrg] = useState('okto'); // Default org
  const [project, setProject] = useState('Prod'); // Default project
  const [user, setUser] = useState(null);

  return (
    <PartnerContext.Provider value={{ org, setOrg, project, setProject, user, setUser }}>
      {children}
    </PartnerContext.Provider>
  );
}; 